export default __webpack_public_path__ + "static/media/certificate.ea6914e5.svg";